<template>
    <div>
        <title-section></title-section>
        
        <section class="services-section section-padding">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="section-title">
                            <router-link to="/my-account">
                                <i class="fa fa-arrow-left mr-2"></i>Regresar
                            </router-link>
                            <h2>Sets</h2>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-lg-12">
                        
                         <div v-if="mensajeError != ''" class="alert alert-danger mb-4" role="alert">
                            <i class="fa fa-exclamation-triangle"></i> <strong>Un momento.</strong> <span>{{ mensajeError }}</span>
                        </div>

                        <div v-if="mensajeExito != ''" class="alert alert-success mb-4" role="alert">
                            <i class="fa fa-check"></i> <strong>Excelente.</strong> <span>{{ mensajeExito }}</span>
                        </div>

                        <div class="text-right mb-3">
                            <a href="javascript:;" @click="cambiarModoAgregarForm()">
                                <i class="fa fa-plus mr-2"></i>Nuevo Set
                            </a>
                        </div>

                        <div class="row">
                            
                            <div class="col-lg-5">

                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <form class="contact-form form"> 
                                            <div class="form-group">
                                                <div class="input-group">
                                                    <input v-model="search" name="search" type="text" class="form-control" placeholder="Buscar..." data-requerido="1">
                                                    <a href="javascript:;" class="input-group-text" @click='consultarSets'><i class="fa fa-search"></i></a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    
                                    <div class="col-lg-12 col-md-12">   
                                        <table class="table table-striped table-hover">
                                            <tbody>
                                                <tr v-for="set in sets" :key="set.id" @click="consultarData(set.id)" :class="{ 'd-none': datosListadoCargados == false }">
                                                    <td>{{ set.name }}</td>
                                                    <td>({{ set.count }} Cartas)</td>
                                                    <td class="text-right">
                                                        <i class="fa fa-edit"></i>
                                                    </td>
                                                </tr>

                                                <tr v-if="sets.length == 0">
                                                    <td colspan="3">No hay resultados que coincidan con su busqueda...</td>
                                                </tr>

                                                <tr :class="{ 'd-none': datosListadoCargados == true }">
                                                    <td colspan="3">Cargando listado...</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="col-lg-7">
                                <div class="card">
                                    <div class="card-body">
                                        <form class="contact-form form" @submit="realizarSubmit"> 
                                            <div class="row">
                                                
                                                
                                                <div class="col-lg-12 col-md-12">
                                                    <div class="form-group">
                                                        <label>Nombre del Set</label>
                                                        <input v-model="name" name="name" type="text" class="form-control" data-requerido="1">
                                                    </div>
                                                </div>


                                                <div class="col-lg-12 col-md-12 text-center mt-4 mb-4" :class="{ 'd-none': datosCargados == false }">
                                                    
                                                    <button type="submit" class="default-btn submit-btn" v-if="modo_form == 'agregar'">
                                                        <i class="fa fa-plus mr-2"></i>Agregar Set<span></span>
                                                    </button>

                                                    <button type="submit" class="default-btn submit-btn mb-3 mr-3" v-if="modo_form == 'editar'">
                                                        <i class="fa fa-edit mr-2"></i>Cambiar nombre del Set<span></span>
                                                    </button>

                                                    <button type="button" class="default-btn submit-btn mb-3 mr-3" @click="visualizarTarjetas()" v-if="modo_form == 'editar'">
                                                        <i class="fa fa-th mr-2"></i>Ver cartas<span></span>
                                                    </button>

                                                    <div class="col-lg-12 col-md-12 text-center" v-if="modo_form == 'editar'">
                                                        <a href="javascript:;" @click="eliminarSet()"><i class="fa fa-times mr-2"></i>Eliminar Set</a>
                                                    </div>
                                                </div>

                                                <div class="col-lg-12 col-md-12 text-center mb-4" :class="{ 'd-none': datosCargados == true }">
                                                    <p>Cargando datos...</p>
                                                </div>

                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </section>

    </div>
</template>

<script>
    import TitleSection from '@/components/TitleSection'
    import Utilities from '@/plugins/Utilities.js'
    import axios from 'axios'

    const MyAccountSets = {
        name: 'MyAccountSets',
        components: {
            TitleSection,
        },
        data: function(){
            return {                
                datosCargados: true,
                datosListadoCargados: true,
                modo_form: 'agregar',
                mensajeExito: '',
                mensajeError: '',

                search: '',
                sets: [],

                id: '',
                name: '',
                count: 0
            }
        },
        methods: {
            cambiarModoAgregarForm(){
                this.id = ''
                this.name = ''

                this.modo_form = 'agregar'
            },
            consultarSets(){
                this.datosListadoCargados = false
                this.mensajeExito = ''
                this.mensajeError = ''

                    
                let _this = this
                this.mensajeError = ''

                const formData = new FormData()
                formData.append('search', this.search)

                axios.post(Utilities.getApiURL()  + 'sets', formData)
                .then(response => {
                    _this.datosListadoCargados = true

                    if(response.data.code == '1'){
                        _this.sets = response.data.sets
                    }
                    else{
                        _this.mensajeError = response.data.message + '(' + response.data.code + ')'
                    }
                })
                .catch(error => {
                    _this.datosListadoCargados = true
                    _this.mensajeError = error
                })
                
            },
            consultarData(id){
                this.datosCargados = false
                this.mensajeExito = ''
                this.mensajeError = ''
                    
                let _this = this
                this.mensajeError = ''

                const formData = new FormData()
                formData.append('id', id)

                axios.post(Utilities.getApiURL()  + 'sets/get', formData)
                .then(response => {
                    _this.datosCargados = true

                    if(response.data.code == '1'){
                        _this.id = response.data.id
                        _this.name = response.data.name
                        _this.count = response.data.count

                        _this.modo_form = 'editar'
                    }
                    else{
                        _this.mensajeError = response.data.message + '(' + response.data.code + ')'
                    }
                })
                .catch(error => {
                    _this.datosCargados = true
                    _this.mensajeError = error
                })
                
            },
            realizarSubmit(e){
                e.preventDefault();
                
                this.datosCargados = false
                this.mensajeExito = ''
                this.mensajeError = ''

                if( this.name != '' ){
                    
                    let _this = this
                    this.mensajeError = ''

                    let url_modo = ''
                    if(this.modo_form == 'agregar'){
                        url_modo = 'add'
                    }
                    else{
                        url_modo = 'edit'
                    }

                    const formData = new FormData()
                    formData.append('id', this.id)
                    formData.append('name', this.name)

                    axios.post(Utilities.getApiURL()  + 'sets/' + url_modo, formData)
                    .then(response => {
                        _this.datosCargados = true

                        if(response.data.code == '1'){
                            _this.search = ''
                            _this.consultarSets()

                            _this.id = ''
                            _this.name = ''
                            _this.count = 0

                            _this.modo_form = 'agregar'

                            setTimeout(function(){
                                _this.mensajeExito = response.data.message
                            }, 1000)
                        }
                        else{
                            _this.mensajeError = response.data.message + '(' + response.data.code + ')'
                        }
                    })
                    .catch(error => {
                        _this.datosCargados = true
                        _this.mensajeError = error
                    })
                }
                else{
                    this.datosCargados = true
                    this.mensajeError = "Debes llenar todos los campos correctamente para poder agregar o editar el set..."
                }
                
            },
            eliminarSet(){
                this.datosCargados = false
                this.mensajeExito = ''
                this.mensajeError = ''
                    
                let _this = this
                this.mensajeError = ''

                const formData = new FormData()
                formData.append('id', this.id)

                axios.post(Utilities.getApiURL()  + 'sets/delete', formData)
                .then(response => {
                    _this.datosCargados = true

                    if(response.data.code == '1'){
                         _this.search = ''
                        _this.consultarSets()

                        _this.id = ''
                        _this.name = ''

                        _this.modo_form = 'agregar'

                        setTimeout(function(){
                            _this.mensajeExito = response.data.message
                        }, 1000)
                    }
                    else{
                        _this.mensajeError = response.data.message + '(' + response.data.code + ')'
                    }
                })
                .catch(error => {
                    _this.datosCargados = true
                    _this.mensajeError = error
                })
                
            },
            visualizarTarjetas(){
                this.$router.push({name:'my-account-sets-cards', params: {id: this.id }})
            },
        },
        watch: {
            search: function(new_value){
                if(new_value.length >= 3 || new_value.length == 0){
                    this.consultarSets()
                }
            }
        },
        beforeMount: function(){
			if(!Utilities.isLogged()){
                this.$router.push({name:'login'})
			}

            this.consultarSets()
		}
    }

    export default MyAccountSets;
</script>

<style scoped>
    .table tr:hover{
        cursor: pointer
    }
</style>